import { Element } from "@xmpp/xml"
import AccountChatsParser, {
  AccountChat,
  ACCOUNT_CHAT_NS,
  USER_CHAT_NS,
} from "./accountChatsParser"

export type AccountChatPubSubEvent = {
  type: "create" | "retract"
  accountChat: AccountChat | { jid: string }
}

export default class AccountChatsPubSubEventParser {
  static parseAccountChat = (
    stanza: Element,
  ): AccountChatPubSubEvent | undefined => {
    return this.parseNode(stanza, ACCOUNT_CHAT_NS, "account-chat-config")
  }

  static parseUserChat = (
    stanza: Element,
    loggedInUserJidBare?: string,
  ): AccountChatPubSubEvent | undefined => {
    return this.parseNode(
      stanza,
      USER_CHAT_NS,
      "user-chat-config",
      loggedInUserJidBare,
    )
  }

  static parse = (stanza: Element): AccountChatPubSubEvent | undefined => {
    return this.parseAccountChat(stanza)
  }

  private static parseNode = (
    stanza: Element,
    nodeName: string,
    configElementName: "account-chat-config" | "user-chat-config",
    loggedInUserJidBare?: string,
  ): AccountChatPubSubEvent | undefined => {
    const node = stanza.getChild("event")?.getChildByAttr("node", nodeName)

    if (!node) return

    if (node.getChild("item")) {
      const item = node.getChild("item")!
      const parsedChat = AccountChatsParser.parseItem(item, {
        configElementName,
        loggedInUserJidBare,
      })

      if (!parsedChat) {
        return {
          type: "retract",
          accountChat: { jid: item.getAttr("id") },
        }
      }

      return {
        type: "create",
        accountChat: parsedChat,
      }
    } else if (node.getChild("retract")) {
      return {
        type: "retract",
        accountChat: { jid: node.getChild("retract")?.getAttr("id") },
      }
    }
  }
}
